module.exports = __webpack_public_path__ + "statics/img/2.0ed37f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/2.png
// module id = gdYc
// module chunks = 1